<div [class.ssr-mask]="!ssrCheck">
  <!-- Offline Overlay -->
  <div class="offline-overlay" *ngIf="isOffline$ | async">
    <div class="offline-overlay__content">
      <div class="offline-overlay__icon">
        <i class="app-ico app-ico__not-available"></i>
      </div>
      <h2 class="offline-overlay__title">{{ 'App.ServerOffline' | translate }}</h2>
      <p class="offline-overlay__message">{{ 'App.ServerOfflineMessage' | translate }}</p>
      <div class="offline-overlay__retry" (click)="checkServerConnectivity()">
        <i class="app-ico-mask app-ico-mask__refresh"></i>
        {{ 'App.RetryConnection' | translate }}
      </div>
    </div>
  </div>
  <div class="header" *ngIf="!(hideHeaderFooter$ | async)">
    <div class="header__inner section-wrapper">
      <ng-container *ngIf="!(isLoggedin$ | async)">
        <div class="header__logo"></div>
        <div class="header__public-links">
          <!-- <a href="https://atalef.ai/recruiters/" target="_blank">Recruiters</a>
          <a href="https://atalef.ai/talent/" target="_blank">Talents</a>
          <a href="https://atalef.ai/partners/" target="_blank">Partners</a>
          <a href="https://atalef.ai/company/" target="_blank">Company</a>
          <a href="https://atalef.ai/contact/" target="_blank">Contact</a> -->
        </div>
        <ng-container *ngIf="!(isMaintenance$ | async)">
          <div *ngIf="!isWelcomePage" class="is-btn is-btn__outfill header__public-signin" (click)="signIn()">{{ 'Auth.SignIn' | translate }}
          </div>
          <!-- <div class="header__menu-icon is-public-menu-icon" (click)="this.togglePublicMenu()">
            <i class="app-ico-mask app-ico-mask__menu"></i>
          </div> -->
        </ng-container>
      </ng-container>

      <div class="header__logo" *ngIf="(isMaintenance$ | async) || (isEmailPolicyBreak$ | async)"></div>
      <div class="header__logo" *ngIf="!(isMaintenance$ | async) && !(isEmailPolicyBreak$ | async) && (isLoggedin$ | async)"
        [routerLink]="[(role$ | async) ? 'dashboard' : 'onboarding']"></div>
      <div class="header__role" *ngIf="(isLoggedin$ | async) && !(isOnboarding$ | async)">
        <ng-container *ngIf="(role$ | async) === USER_ROLES.talent">
          <i class="app-ico app-ico__type-talent"></i> {{ 'Header.Talent' | translate }}
        </ng-container>
        <ng-container *ngIf="(role$ | async) === USER_ROLES.hm || (role$ | async) === USER_ROLES.accountAdmin">
          <i class="app-ico app-ico__type-company"></i>
          <span>{{ 'Header.Recruiter' | translate }}</span>
         <span class="header__role-star" *ngIf="isAccountAdmin$ | async" [title]="'Header.AccountAdmin' | translate" [attr.aria-label]="'Header.AccountAdmin' | translate" role="img">&#9733;</span>
        </ng-container>
      </div>

      <div
        class="is-btn is-btn__outfill header__stop-impersonation"
        *ngIf="isImpersonating() && !(isLoggedin$ | async)"
        (click)="stopImpersonation()">
        {{ 'Header.StopImpersonating' | translate }}
      </div>

      <div class="header__profile" *ngIf="(isLoggedin$ | async) && !(isMaintenance$ | async)">
        <div class="header__profile__inner" (click)="toggleProfileMenu(true)">
          <div class="header__profile__avatar" [avatarImage]="userAvatar$ | async">
            <div *ngIf="isIncognito$ | async" class="header__profile__avatar__blur"></div>
            <i *ngIf="isIncognito$ | async" class="app-ico app-ico__not-available"></i>
          </div>
          <div class="header__profile__info">
            <div class="header__profile__name" *ngIf="name$ | async">{{ name$ | async }}</div>
            <div class="header__profile__mail">{{ email$ | async }}</div>
          </div>
          <div>
            <i class="app-ico-mask app-ico-mask__select-arrow-down"></i>
          </div>
        </div>
        <ng-container *ngIf="(role$ | async) as role; else noRole">
          <div class="header__profile__menu-bg" *ngIf="showProfileMenu" (click)="toggleProfileMenu(false)"></div>
          <div class="header__profile__menu" *ngIf="showProfileMenu" (click)="toggleProfileMenu(false)">
            <div class="header__profile__menu__item" *ngIf="!(isOnboarding$ | async) && !(isBlocked$ | async)"
              [routerLink]="[(role === USER_ROLES.talent ? '/talent' : 'hm') + '/profile']"
              [routerLinkActive]="['is-active']">
              <i class="app-ico app-ico__menu-profile"></i>{{ 'Header.Profile' | translate }}
            </div>
            <div class="header__profile__menu__item" *ngIf="!(isOnboarding$ | async) && !(isBlocked$ | async)"
              [routerLink]="[(role === USER_ROLES.talent ? '/talent' : 'hm') + '/settings']"
              [routerLinkActive]="['is-active']">
              <i class="app-ico app-ico__menu-settings"></i>{{ 'Header.Settings' | translate }}
            </div>
            <div class="header__profile__menu__item" *ngIf="(isAccountAdmin$ | async) && !(isOnboarding$ | async) && !(isBlocked$ | async)"
              [routerLink]="['/dashboard/upgrade']"
              [routerLinkActive]="['is-active']">
              <i class="app-ico app-ico__menu-dashboard"></i>{{ 'Header.Upgrade' | translate }}
            </div>
            <div class="header__profile__menu__item" *ngIf="(isAdmin$ | async) && !isImpersonating()" (click)="showImpersonateDialog = true; toggleProfileMenu(false)">
              <i class="app-ico app-ico__menu-impersonate"></i>{{ 'Header.ImpersonateUser' | translate }}
            </div>
            <div class="header__profile__menu__item is-impersonating" *ngIf="isImpersonating()" (click)="stopImpersonation()">
              <i class="app-ico app-ico__menu-impersonate"></i>{{ 'Header.StopImpersonating' | translate }}
            </div>            
            <div class="header__profile__menu__item is-sign0out" (click)="logout()">
              <i class="app-ico app-ico__menu-sign-out"></i>{{ 'Header.SignOut' | translate }}
            </div>
          </div>
        </ng-container>
        <ng-template #noRole>
          <div class="header__profile__menu-bg" *ngIf="showProfileMenu" (click)="toggleProfileMenu(false)"></div>
          <div class="header__profile__menu" *ngIf="showProfileMenu">
            <div class="header__profile__menu__item is-sign0out" (click)="logout()">
              <i class="app-ico app-ico__menu-sign-out"></i>{{ 'Header.SignOut' | translate }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="header__menu-icon" *ngIf="(isLoggedin$ | async) && !(isMaintenance$ | async)"
        (click)="this.toggleMenu()">
        <i class="app-ico-mask app-ico-mask__menu"></i>
        <div class="header__menu-msg-count" *ngIf="messageCount$ | async">
          {{ messageCount$ | async }}
        </div>
      </div>
    </div>
    <div class="header__menu" *ngIf="showMenu && !(isMaintenance$ | async)" @dropMenu>
      <div class="header__menu__bg is-bg" (click)="this.toggleMenu()"></div>
      <main-menu (click)="this.toggleMenu()" [isOnboarding]="isOnboarding$ | async" [isBlocked]="isBlocked$ | async"
        [isMobile]="true">
      </main-menu>
    </div>
    <!-- <div class="header__menu" *ngIf="showPublicMenu" @dropMenu>
      <div class="header__menu__bg is-bg" (click)="this.togglePublicMenu()"></div>
      <ul class="header__menu__public-links">
        <li><a href="https://atalef.ai/recruiters/" target="_blank">Recruiters</a></li>
        <li><a href="https://atalef.ai/talent/" target="_blank">Talents</a></li>
        <li><a href="https://atalef.ai/partners/" target="_blank">Partners</a></li>
        <li><a href="https://atalef.ai/company/" target="_blank">Company</a></li>
        <li><a href="https://atalef.ai/contact/" target="_blank">Contact</a></li>
      </ul>
    </div> -->
  </div>

  <!-- Impersonation Dialog -->
  <div class="impersonation-dialog" *ngIf="showImpersonateDialog">
    <div class="notify-popup-bg" (click)="onImpersonationDialogClose()"></div>
    <div class="notify-popup">
      <i class="app-ico-mask app-ico-mask__x" (click)="onImpersonationDialogClose()"></i>
      <h2>{{ 'App.ImpersonateUser' | translate }}</h2>
      <div class="input-wrapper">
        <div class="form-group" [class.invalid]="isSubmitted && emailForm.get('email')?.invalid">
          <label>{{ 'App.UserEmail' | translate }}</label>
          <input
            type="email"
            [formControl]="emailControl"
            (keyup.enter)="startImpersonation()"
            [placeholder]="'App.EnterUserEmail' | translate"
            class="form-control"
            [class.is-invalid]="isSubmitted && emailControl.invalid"
            autofocus>
          <div *ngIf="isSubmitted && emailControl.hasError('required')" class="invalid-feedback">
            {{ 'App.EmailRequired' | translate }}
          </div>
          <div *ngIf="isSubmitted && emailControl.hasError('email')" class="invalid-feedback">
            {{ 'App.ValidEmailRequired' | translate }}
          </div>
        </div>
      </div>
      <div class="notify-popup__btns">
        <div class="is-btn is-btn__outfill" (click)="onImpersonationDialogClose()">{{ 'Common.Cancel' | translate }}</div>
        <div 
          class="is-btn" 
          [class.is-disabled]="emailForm.invalid" 
          (click)="!emailForm.invalid && startImpersonation()">
          {{ 'App.Impersonate' | translate }}
        </div>
      </div>
    </div>
  </div>

  <notify-popup *ngIf="(isIncognito$ | async) && (incognitoNotify$ | async)"
    (onChanged)="incognitoNotifyConfirm($event)" [cancelLabel]="'Common.Cancel' | translate" [okLabel]="'Common.Apply' | translate"
    [title]="'App.DeAnonymizedWarningTitle' | translate"
    [msg]="'App.DeAnonymizedWarningMessage' | translate"
    [checkboxStorageKey]="'noIncognitoNotify'">
  </notify-popup>

  <div class="main-area" id="host-position">
    <router-outlet></router-outlet>
  </div>

  <div class="footer" *ngIf="!(hideHeaderFooter$ | async)">
    <div class="footer__inner section-wrapper">
      <div>
        <a *ngIf="socialMediaUrls.facebook" [href]="socialMediaUrls.facebook" target="_blank">
          <i class="app-ico app-ico__social-facebook"></i>
        </a>
        <a *ngIf="socialMediaUrls.instagram" [href]="socialMediaUrls.instagram" target="_blank">
          <i class="app-ico app-ico__social-instagram"></i>
        </a>
        <a *ngIf="socialMediaUrls.telegram" [href]="socialMediaUrls.telegram" target="_blank">
          <i class="app-ico app-ico__social-telegram"></i>
        </a>
        <a *ngIf="socialMediaUrls.linkedin" [href]="socialMediaUrls.linkedin" target="_blank">
          <i class="app-ico app-ico__social-linkedin"></i>
        </a>
      </div>
      <div class="footer__inner__links">
        <!-- <a [routerLink]="['/page/fees']">Hiring Fee</a> -->
        <a target="_blank" href="https://atalef.ai/wp-content/atalef-privacy-policy.pdf">{{ 'App.PrivacyPolicy' | translate }}</a>
        <a target="_blank" href="https://atalef.ai/wp-content/atalef-terms.pdf">{{ 'App.TermsConditions' | translate }}</a>
      </div>
      <a class="footer__inner__mail" href="mailto:support@atalef.ai">
        <i class="app-ico-mask app-ico-mask__envelope"></i>support&#64;atalef.ai
      </a>
    </div>
    <div class="footer__copy">
      &copy; Atalef {{ currentYear }} &nbsp;&nbsp;|&nbsp;&nbsp;
      <span class="version" [title]="'API Version: ' + apiVersion + '\nApp Version: ' + appVersion">
        {{ versionString }}
      </span>
    </div>
  </div>
</div>
